import { create } from 'zustand';

export type RedirectCause = 'sessionExpired' | 'needLogin' | 'logout';

export interface RedirectInfo {
    pageId: string;
    routeData?: unknown;
    query?: string | URLSearchParams;
    cause?: string;
    at?: number;
}

interface RedirectStoreState {
    redirect: RedirectInfo | undefined;
    setRedirectInfo: (info: RedirectInfo) => void;
    consumeRedirect: () => RedirectInfo | undefined;
    clear: () => void;
}

export const useRedirectStore = create<RedirectStoreState>((set, get) => ({
    redirect: undefined,
    setRedirectInfo: (info: RedirectInfo) => {
        set((state) => {
            return {
                ...state,
                redirect: info,
            };
        });
    },

    consumeRedirect: () => {
        const info = get().redirect;
        set({ redirect: undefined });
        return info;
    },
    clear: () => {
        set({ redirect: undefined });
    },
}));
